import { PageId } from 'constants/pages'

export const enum PageIdWoofzNdd65 {
  SUBSCRIPTIONS_NDD_65 = PageId.SUBSCRIPTIONS_NDD_65,
  CHAT_UPSELL_NDD_65 = PageId.CHAT_UPSELL_NDD_65,
  UPSELL_NDD_65 = PageId.UPSELL_NDD_65,
  DOWNLOAD_NDD_65 = PageId.DOWNLOAD_NDD_65,
  ACCOUNT_NOVE8 = PageId.ACCOUNT_NOVE8,
}
